/** 业务 API（登录、用户等），与 PDF 服务地址分离 */
const HTTP_REQUEST_URL =
  process.env.VUE_APP_HTTP_BASE || 'https://api.aiyqzx.com/app/v1/'

module.exports = {
  HTTP_REQUEST_URL,
  FILE_UPLOAD_URL: `${HTTP_REQUEST_URL.replace(/\/$/, '')}/file`,
  TOKEN_NAME: 'token'
}
